export enum ErrorStatus {
  UserNotFoundError = 'USER_NOT_FOUND_ERROR',
  InvalidLoginCredentialError = 'INVALID_LOGIN_CREDENTIAL_ERROR',
  LoginFailedManyTimesError = 'LOGIN_FAILED_MANY_TIMES_ERROR',
  UserExistedError = 'USER_EXISTED_ERROR',
  ExistedUsername = 'EXISTED_USERNAME',
  ExistedDisplayName = 'EXISTED_DISPLAYNAME',
  EmailNotFoundError = 'EMAIL_NOT_FOUND_ERROR',
  LimitRequestEmail = 'LIMIT_REQUEST_EMAIL',
  InvalidCurrentPasswordError = 'INVALID_CURRENT_PASSWORD_ERROR',
  WrongCurrentPassword = 'WRONG_CURRENT_PASS',
  UserRegisterManyTime = 'USER_REGISTER_MANYTIME',
  Default = 'DEFAULT',
  LockedAccount = 'LOCKED_ACCOUNT',
  CaptchaVerificationError = 'CAPTCHA_VERIFICATION_ERROR'
}
